var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20H4.5C2.42891 20 0.75 18.3211 0.75 16.25V13.4375C0.75 12.918 1.16992 12.5 1.6875 12.5C2.20547 12.5 2.625 12.9199 2.625 13.4375V16.25C2.625 17.2812 3.46875 18.125 4.5 18.125H14.5C15.5312 18.125 16.375 17.2812 16.375 16.25V13.4375C16.375 12.9199 16.7949 12.5 17.3125 12.5C17.8305 12.5 18.25 12.9199 18.25 13.4375V16.25C18.25 18.3203 16.5703 20 14.5 20ZM10.1406 13.4961L15.4531 8.49609C15.8316 8.14086 15.8484 7.54766 15.4934 7.17148C15.1394 6.7943 14.5461 6.77617 14.1688 7.13121L10.4375 10.6406V0.9375C10.4375 0.419922 10.0195 0 9.5 0C8.98047 0 8.5625 0.419922 8.5625 0.9375V10.6406L4.82812 7.12891C4.45234 6.77344 3.85898 6.79297 3.50508 7.17188C3.33437 7.35156 3.25 7.58203 3.25 7.8125C3.25 8.06152 3.34887 8.31055 3.54539 8.49492L8.85789 13.4949C9.21875 13.8359 9.78125 13.8359 10.1406 13.4961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.bd867e329386e31792489c4ed237e609.svg";
export { ForwardRef as ReactComponent };